import {DateHelpers} from '../../../../helpers/date-helpers';

export const Normalizer = {
  fetch: (state, data) => {
    return {
      ...state,
      init: true,
      fields: {
        ...state.fields,
        ...data.fields,
        extended: data.extended,
      },
      options: { ...state.options, ...data.options },
    };
  },

  send: (values, isSendJobButton = false) => {
    const params = {};

    Object.keys(values)
      .filter(k => values[k] !== null && !['searchType', 'clients'].includes(k))
      .forEach(k => {
        if (['processIds', 'status'].includes(k)) {
          params[k] = values[k].map(r => r.value);
        } else if (k === 'sendEmail') {
          params[k] = values[k].value;
        } else if (k === 'dateApply') {
          params[k] = DateHelpers.jsDateToString(new Date(values[k]));
        } else {
          params[k] = values[k];
        }
      });

    if (isSendJobButton) {
      if (values.searchType.assigned) {
        params.forceEmailSetup = values.searchType.assigned;
      } else {
        // params.id = values.candidateId;
        // delete params.candidateId;
      }
    }

    return params;
  },
};
